import { useOrder, createOrder } from '../data/order'
import AuthService from '../services/authentication';
import React, { useState } from "react"
import { useHistory } from "react-router-dom"
import { Button, Input, Label } from "../ui"

function CreateOrderForm(props) {
  let auth = AuthService.useAuth();
  let history = useHistory()
  const [formValues, setFormValues] = useState({email: '', firstName: '', lastName: '', phone: ''})

  const { order, mutate } = useOrder(auth.authHeader());

  const handleSubmit = async event => {
    event.preventDefault();
    try {
      const response = await createOrder({
        patient: {
          ...formValues,
        },
        auth_header: auth.authHeader()
      });
      mutate()
      history.push("/order/edit");
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    setFormValues({
      ...formValues,
      [name]: value
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-12 gap-2">
        {props.label && <Label className="col-span-12">{props.label}</Label>}
        <div className="col-span-6">
          <Input name="firstName" required onChange={handleInputChange} type="text" placeholder="Patient first name" />
        </div>
        <div className="col-span-6">
          <Input name="lastName" required onChange={handleInputChange} type="text" placeholder="Patient last name" />
        </div>
        <div className="col-span-12">
            <Input name="email" required onChange={handleInputChange} type="email" placeholder="Patient email address" />
        </div>
        <div className="col-span-12">
            <Input name="phone" required onChange={handleInputChange} type="text" placeholder="Patient phone number" />
        </div>
        <div className="col-span-6">
          <Button variant="primary" className="mrt-4" type="submit">Next</Button>
        </div>
      </div>
    </form>
  )
}

export default CreateOrderForm
